import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { browserHistory } from 'react-router';
import { PartnerStudentVariationListService } from '../../services/CustomerSuccessKpiListService';
import PartnerStudentVariationTable from './PartnerStudentVariationTable';

class PartnerStudentVariationTableContainer extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
  };

  constructor(props) {
    super(props);
    PartnerStudentVariationListService.load();
  }

  render() {
    return (
      <PartnerStudentVariationTable
        loading={
          PartnerStudentVariationListService.fetchCurrent.fetching ||
          PartnerStudentVariationListService.fetchPrevious.fetching
        }
        values={toJS(
          get(
            PartnerStudentVariationListService,
            { segment: 'bySegment', distributor: 'byDistributor' }[this.props.type],
            []
          )
        )}
        feedbackColorRender={PartnerStudentVariationListService.getFeedbackColor}
        onSelect={(row) => browserHistory.push(`/kpis/customer-success/${this.props.type}/${row.id}/details`)}
        formatter={PartnerStudentVariationListService.getFormattedValue}
        additionalColumns={[
          {
            label: 'Standard Deviation',
            path: 'currentStandardDeviation',
          },
          {
            label: 'Total of Registers',
            path: 'currentCompanyAmount',
          },
        ]}
      />
    );
  }
}

export default observer(PartnerStudentVariationTableContainer);
